import React from "react"
import "./styles.scss"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.scss"
import Img from "gatsby-image"
const Gallery = ({ galleryImages, isDesktop }) => {
  if (isDesktop) {
    return (
      <section className={`section section--gallery ${galleryImages.length < 6 ? 'section--gallery-small' : ''}`}>
        <div className="wrapper">
          <div className="gallery">
            {galleryImages.map((image, i) => {
              return (
                <div
                  data-sal="fade"
                  data-sal-duration="1000"
                  data-sal-easing="ease"
                  key={i}
                >
                  <Img fluid={ image?.image?.childImageSharp?.fluid || image?.imageSingle[0].image.childImageSharp.fluid} alt="" />
                </div>
              )
            })}
          </div>
        </div>
      </section>
    )
  } else {
    return (
      <section className="section section--gallery">
        <div className="wrapper">
          <div className="galleryMobile">
            <Swiper slidesPerView={1.2} spaceBetween={24}>
              {galleryImages.map((image, i) => {
                return (
                  <SwiperSlide key={i}>
                                      <Img fluid={ image?.image?.childImageSharp?.fluid || image?.imageSingle[0].image.childImageSharp.fluid} alt="" />

                  </SwiperSlide>
                )
              })}
            </Swiper>
          </div>
        </div>
      </section>
    )
  }
}

export default Gallery
